/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 15:13:06
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 15:24:39
 * @name: 工单管理-查询物流信息
 * @Description: 工单管理-查询物流信息
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\issue\getPackageInfo.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'com',
    description: '快递100公司代码',
    required: true,
    required_message: '请输入快递公司',
    match: (e) => {
      if (!e) {
        return '请输入快递公司';
      } else {
        return '';
      }
    }
  },
  {
    key: 'num',
    description: '单号',
    required: true,
    required_message: '请输入单号',
    match: (e) => {
      if (!e) {
        return '请输入单号';
      } else {
        return '';
      }
    }
  },
]